<template>
  <div class="my_link_index m-lr-11">
    <p :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span
        v-text="title"
        class="title"
        :style="{
        width: titleWidth + 'px'
      }"
      ></span>
      <el-input
        class="module"
        v-model="Result"
        :placeholder="placeholder"
        :disabled="disabled"
        size="small"
        :style="{
          width: width+ 'px'
        }"
      ></el-input>
      <span class="link_button">
        <el-button
          v-text="buttonName"
          size="small"
          @click="setLink"
        ></el-button>
      </span>
    </p>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_link_index',
  props: {
    titleWidth: {
      type: String,
      default: '40'
    },
    title: { // 组件的标题
      type: String,
      default: i18n.t('view_contact_us_edit_107')
    },
    buttonName: { // 组件的标题
      type: String,
      default: i18n.t('components_my_link_index_2361')
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'one_level'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '160'
    },
    link: {
      type: Object,
      default: null
    },
    linkFun: { // 仅仅是只显示功能 其他的不显示
      type: Boolean,
      default: false
    },
    contactUs: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Result: this.link.select_val_preview
    }
  },
  mounted () {
  },
  watch: {
    'link.select_val_preview' (val) {
      this.Result = val
    }
  },
  computed: {
  },
  methods: {
    setLink () {
      this.$store.commit('set_link/set_link_dialog_show', true);
      this.$store.commit('set_link/set_link_edit', this.link);
      // 设置 只显示功能 其他的选项不显示 设置   link_fun
      this.$store.commit('set_link/set_link_fun', this.linkFun);
      this.$emit('setLink')
      if(this.contactUs) {
        this.$store.commit('set_link/set_link_contact_us', true);
      }
    },
  }
}
</script>

<style scoped type="text/css" lang="scss">
.module {
  & /deep/ .el-input__inner {
    text-overflow: ellipsis;
  }
}
.link_button {
  display: inline-block;
  margin-left: 10px;
  width: 80px;
}
.link_button {
  & /deep/ .el-button.el-button--small {
    padding: 9px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_link/index.vue